<!-- 横向导航 -->
<template>
  <div class="zlr-menu-row">
    <ul v-if="!onlyExpert">
      <!-- class="active"  -->
      <li v-for="(item,index) in menuList"
          :key="index"
          :class="[$route.matched.some(({name}) => item.name.includes(name))?'active':'']">
        <a @click="routerHandle(item.name[0])">{{item.title}}</a>
        <div class="slash"
             v-show="index !== menuList.length-1">/</div>
      </li>
    </ul>
  </div>
</template>

<script>
import './menu.less'
export default {
  name: '',
  props: {
    menuList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {},
  data () {
    return {
      onlyExpert: false
    }
  },
  computed: {},
  mounted () { 
    this.onlyExpert = Boolean(this.$route.query.type)
  },
  methods: {
    routerHandle (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
